/* eslint-disable no-unused-expressions */
import { Card, Form, Grid, Input, Picker, PhoneInput } from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'
import { useForm } from 'react-hook-form'
import { ResGetAllContracts } from 'services/Supplier/LogicalEffective'
import { SPACING } from 'utils'

interface RegisterEffectivesProps {
  contractData?: ResGetAllContracts
}

const DadosEmpresa = ({ contractData }: RegisterEffectivesProps) => {
  const { handleSubmit } = useForm<RegisterEffectivesProps>()
  // REGEX que vai identificar se existe as siglas SubContrato ou Quartenário no contrato, caso sim, o elemento de empresa secundária irá aparecer na tela
  const mostrarElemento = /(SC|SC.*Q)/g.test(contractData.cdContrato);

  // Retorna o contrato principal do SubContrato
  const index = contractData.cdContrato.indexOf('SC');
  const contratoPrincipal = contractData.cdContrato.substring(0, index) || contractData.cdContrato

  let nmFornecedor = contractData?.nmFornecedor
  let cnpjPassaporte = contractData?.cdCnpj
  const isSubContrato = /(SC|SC.*Q)/g.test(contractData?.cdContrato);
  if (isSubContrato) {
    nmFornecedor = contractData?.nmFornecedorPrincipal
    cnpjPassaporte = contractData?.cdCnpjPrincipal
  }

  return (
    <Card marginBottom={SPACING.spacing5}>
      <SimpleCollapse title="DADOS DA EMPRESA" isExpanded>
        <Form onSubmit={handleSubmit(DadosEmpresa)}>
          <Grid
            gridCols="3fr 1fr 1fr 3fr"
            gridGap="1rem"
            padding={`${SPACING.spacing10} 0 ${SPACING.spacing30}`}
          >
            <Input
              label="Empresa Principal"
              placeholder="Nome da Empresa"
              value={nmFornecedor}
              disabled
            />
            <Input
              label="Contrato"
              placeholder="Nº"
              value={contratoPrincipal}
              disabled
            />
            <Input
              label="CPF/CNPJ/Cód.Fornecedor"
              placeholder="Nº"
              value={cnpjPassaporte}
              mask={
                cnpjPassaporte && cnpjPassaporte.length > 9 
                ? ['###.###.###-##', '##.###.###/####-##']
                : ['#########']
              }
              disabled
            />
          </Grid>
          <div>
            {mostrarElemento ? (
              <Grid
                gridCols="3fr 1fr 1fr 3fr"
                gridGap="1rem"
                padding={`0 0 ${SPACING.spacing30}`}
              >
                <Input
                  label="Empresa Secundária (Opcional)"
                  placeholder="Nome da Empresa"
                  value={contractData.nmFornecedor}
                  disabled
                />
                <Input
                  label="Contrato (Opcional)"
                  placeholder="Nº"
                  value={contractData.cdContrato}
                  disabled
                />
                <Input
                  label="CPF/CNPJ/Cód.Fornecedor"
                  placeholder="Nº"
                  value={contractData.cdCnpj}
                  mask={
                    contractData.cdCnpj && contractData.cdCnpj.length > 9 
                    ? ['###.###.###-##', '##.###.###/####-##']
                    : ['#########']
                  }
                  disabled
                />
              </Grid>
            ) : null}
          </div>
          <Grid
            gridCols="1fr"
            gridGap="1rem"
            padding={`0 0 ${SPACING.spacing30}`}
          >
            <Input
              label="Descrição da Atividade"
              placeholder="Descrição da Atividade"
              value={contractData.objetoContrato}
              disabled
            />
          </Grid>
          <Grid
            gridCols="1.5fr 1.5fr 1fr 3fr 1fr"
            gridGap="1rem"
            padding={`0 0 ${SPACING.spacing30}`}
          >
            <Picker
              value={contractData.dtInicioVigencia}
              label="Data Início"
              allowTyping={false}
              disabled
            />
            <Picker
              value={contractData.dtFimVigencia}
              label="Data Final"
              allowTyping={false}
              disabled
            />
            <Input
              label="Matrícula"
              placeholder="Matrícula Contraparte"
              value={contractData.cdMatriculaContraparte}
              disabled
            />
            <Input
              label="Contraparte CSN"
              placeholder="Nome do Constraparte"
              value={contractData.nmContraparte}
              disabled
            />
            <Input
              label="Ramal"
              placeholder="Ramal"
              value={contractData.nuRamalContraparte}
              disabled
            />
          </Grid>
          <Grid
            gridCols="2fr 1.5fr 2fr 1.5fr"
            gridGap="1rem"
            padding={`0 0 ${SPACING.spacing10}`}
          >
            <Input
              label="Responsável da Empresa"
              placeholder="Nome do Responsável"
              value={contractData?.nmFornecedor}
              disabled
              marginTop="3px"
            />
            <PhoneInput
              label="Telefone do Responsável (Opcional)"
              placeholder="DDD + Número"
              value={contractData.telefoneResponsavel}
              disabled
            />
            <Input
              label="Endereço da Empresa"
              placeholder="Logradouro"
              value={contractData.enderecoEmpresa}
              marginTop="3px"
              disabled
            />
            <PhoneInput
              label="Telefone da Empresa (Opcional)"
              placeholder="DDD + Número"
              value={contractData.telefoneEmpresa}
              disabled
            />
          </Grid>
        </Form>
      </SimpleCollapse>
    </Card>
  )
}

export default DadosEmpresa
